import { render, staticRenderFns } from "./OfferBookingAddTalentModalManager.vue?vue&type=template&id=68bb3036&scoped=true"
import script from "./OfferBookingAddTalentModalManager.vue?vue&type=script&lang=js"
export * from "./OfferBookingAddTalentModalManager.vue?vue&type=script&lang=js"
import style0 from "./OfferBookingAddTalentModalManager.vue?vue&type=style&index=0&id=68bb3036&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68bb3036",
  null
  
)

export default component.exports